import {Splide} from '@splidejs/splide';
import 'bootstrap';

window.addEventListener('load', () => {
    const slider_elements = document.querySelectorAll('.splide');

    slider_elements.length && slider_elements.forEach(slider => {
        slider.splide = new Splide( '.splide', {
            type   : 'loop',
            autoplay: false,
            arrows: true,
            pagination: true,
            perPage: 1,
        } );

        const images = slider.querySelectorAll('img'), indicators = slider.querySelector('.indicators');

        for (const image of images) {
            if (!image.dataset.srcset) continue;

            image.srcset = image.dataset.srcset;
        }

        slider.splide.mount();

        if (indicators) {
            const pagination = slider.querySelector('.splide__pagination'), arrows = slider.querySelector('.splide__arrows');

            slider.querySelector('.indicators').appendChild(pagination);
            arrows.style.display = 'flex';
        }
    });

    document.addEventListener('click', event => {
        if(!event.target.closest('.nav_link--dropdown')) return;

        const dropdown = event.target.closest('.nav_link--dropdown'), subMenu = dropdown.nextElementSibling;

        dropdown.classList.toggle('active');
        subMenu.classList.toggle('active');
    });

    document.addEventListener('click', event => {
        if(!event.target.closest('.hamburger-x')) return;

        const toggleButton = document.querySelector('.navbar-toggler');

        toggleButton.click();
    });
});